import type { Questionnaire } from '@core/fhir-r4/fhir';

export type TriageQuestionType =
  | 'single'
  | 'boolean'
  | 'categorical-single-choice'
  | 'multiple-choice'
  | 'group-single'
  | 'group-multiple'
  | 'symptoms'
  | 'slider'
  | 'free-text'
  | 'text-input'
  | 'list'
  | 'image-upload';

export type TriageNumericFormat = 'integer' | 'decimal';

export interface TriageAttachmentAnswer {
  title: string;
  contentType?: string;
  data?: string;
  size?: number;
  url?: string;
}

export type TriageAnswerValue = string | number | boolean | readonly string[] | TriageAttachmentAnswer;
export type TriageAnswerRecord = Readonly<Record<string, TriageAnswerValue>>;

// UI-only marker kept in journey answers so "None of the above" survives navigation; never sent to the provider.
export const noneOfTheAboveAnswerCode = '__none_of_the_above__';

export interface TriageChoiceOption {
  code: string;
  label: string;
  system?: string;
  hint?: string;
}

export interface TriageQuestionMetadata {
  questionType?: string;
  answerType?: string;
  explanatoryText?: string;
  sourceListUrl?: string;
  sliderTitle?: string;
  unit?: string;
  minimumValue?: number;
  maximumValue?: number;
  maximumLength?: number;
}

export interface TriageQuestion {
  linkId: string;
  text: string;
  type: TriageQuestionType;
  required: boolean;
  options?: readonly TriageChoiceOption[];
  children?: readonly TriageQuestion[];
  allowsMultiple?: boolean;
  numericFormat?: TriageNumericFormat;
  metadata?: TriageQuestionMetadata;
}

export interface TriageQuestionnaire {
  id: string;
  title: string;
  encounterId: string;
  workflowStepIdentity?: TriageWorkflowStepIdentity;
  questions: readonly TriageQuestion[];
  source?: Questionnaire;
}

export interface TriageWorkflowStepIdentity {
  journeyRevision: number;
  stepSequence: number;
  questionnaireEventSequence: number;
}